/** Fallback until Prismic Theme document is fetched per store (TLP defaults). */
export const MOCK_PRISMIC_THEME = {
    "background-theme": "#ffffff",
    "primary-200": "#d8dce3",
    "secondary-100": "#eef9e0",
    "secondary-200": "#e5f3d4",
    "text-color-default": "#2a384e",
    "heading-color": "#37404e",
    "gray-50": "#f2f4f7",
    "gray-200": "#d8dce3",
    "gray-300": "#bbc1c9",
    "gray-400": "#858f9d",
    "gray-600": "#37404e",
    black: "#030405",
    errors: "#cc321b",
    "btn-primary": "#6baa33",
    "label-btn-primary": "#ffffff",
    "border-btn-primary": "#6baa33",
    "btn-primary-hover": "#6baa33",
    "label-btn-primary-hover": "#ffffff",
    "border-btn-primary-hover": "#6baa33",
    "btn-secondary": "#fafbfc",
    "label-btn-secondary": "#030405",
    "background-btn-secondary": "#fafbfc",
    "btn-secondary-hover": "#f2f4f7",
    "label-btn-secondary-hover": "#1b2129",
    "background-btn-secondary-hover": "#f2f4f7",
    "border-width-btn": "1px",
    "border-radius-btn": "16px",
    "cart-empty-bag-base-color": "#B3B3B3",
    "cart-empty-bag-trace-base-color": "#4D4D4D",
    "cart-empty-bag-side-color": "#85BB5C",
    "cart-empty-bag-lateral-stroke": "#528829",
    "cart-empty-bag-front-bag": "#C2DDAD",
    "cart-empty-bag-signal": "#FFC941",
    "cart-empty-bag-shadow": "#989898",
    "cart-empty-bag-counter-badge": "#E44E41",
    "cart-empty-bag-text-counter-badge": "#FAFAFA",
    "cart-empty-bag-strap": "#528829",
};

export const BAG_DEFAULTS = {
    bagBaseColor: "#B3B3B3",
    bagTraceBaseColor: "#4D4D4D",
    bagSideColor: "#85BB5C",
    bagLateralStroke: "#528829",
    bagFrontBag: "#C2DDAD",
    bagSignal: "#FFC941",
    bagShadow: "#989898",
    bagCounterBadge: "#E44E41",
    bagTextCounterBadge: "#FAFAFA",
    bagStrap: "#528829",
};

/** Declined illustration defaults (Stripo Vector SVG). */
export const DECLINED_DEFAULTS = {
    declinedInk: "#0D0D0D",
    declinedMark: "#66AA33",
    declinedButton: "#66AA33",
};
